import { gql } from '@apollo/client';

import { SubjectFragment } from '../graphql/startup-data/startup-data.graphql';
import { ResponsiveImageFragment } from '../graphql/responsive-images/responsive-images.graphql';
import { studentLessonStimulusFragment } from 'approot/student-lesson/sections/stimulus/stimulus.graphql';
import {
  studentLessonLandscapeImageFragment,
  studentLessonSquareImageFragment,
} from 'approot/student-lesson/student-lesson.graphql';
import { studentLessonWorksheetsFragment } from 'approot/student-lesson/sections/worksheets/worksheets.graphql';
import { studentLessonPrintablesFragment } from 'approot/student-lesson/sections/printables/printables.graphql';
import {
  studentAssessmentLandscapeImageFragment,
  studentAssessmentSquareImageFragment,
} from 'approot/student-assessment/student-assessment.graphql';
import { studentAssessmentWorksheetsFragment } from 'approot/student-assessment/sections/worksheets/worksheets.graphql';
import { studentAssessmentStimulusFragment } from 'approot/student-assessment/sections/stimulus/stimulus.graphql';

export const BookmarkedSectionOverviewFragment = gql`
  fragment BookmarkedSectionOverviewFragment on ActivitiesSectionOverview {
    id
    activityId
    differentiation
    checkPoint
    sort
    pageType
    isAssigned
    hasResponseComponents
    subSectionsOverview {
      id
      activityId
      differentiation
      checkPoint
      parentSectionId
      sort
      pageType
      isAssigned
      hasResponseComponents
    }
  }
`;

export const GET_ASSIGNMENT_BY_ID = gql`
  query GetAssignmentById($input: GetAssignmentByIdInput!) {
    getAssignmentById(input: $input) {
      id
      isAssigned
      isAutomarkable
      submittedStudentCount
      assignedActivities {
        ... on LessonActivities {
          id
          language
          version
          styles {
            fontSize
          }
          focusQuestion {
            value
          }
          phenomena {
            value
          }
          landscapeImage {
            ...ResponsiveImageFragment
          }
          lesson {
            name
            unit {
              id
              name
            }
            subjects {
              id
              label
            }
          }
          sectionsOverview {
            id
            isAssigned
            checkPoint
            differentiation
            sort
            pageType
            activityId
            hasResponseComponents
            subSectionsOverview {
              id
              differentiation
              parentSectionId
              pageType
              sort
              isAssigned
              checkPoint
              activityId
              hasResponseComponents
            }
          }
          assetKeys {
            print {
              language
              key
              publicToken
            }
            studentPrintables {
              language
              key
              publicToken
            }
          }
        }
        ... on AssessmentActivities {
          id
          language
          version
          styles {
            fontSize
          }
          assessmentName
          landscapeImage {
            ...ResponsiveImageFragment
          }
          assessment {
            name
            unit {
              id
              name
            }
            subjects {
              id
              label
            }
          }
          sectionsOverview {
            id
            isAssigned
            checkPoint
            differentiation
            sort
            pageType
            activityId
            hasResponseComponents
            subSectionsOverview {
              id
              differentiation
              parentSectionId
              pageType
              sort
              isAssigned
              checkPoint
              activityId
              hasResponseComponents
            }
          }
          assetKeys {
            print {
              language
              key
              publicToken
            }
            studentPrintables {
              language
              key
              publicToken
            }
          }
        }
      }
      assignedContentData {
        ... on AssignedLessonData {
          type
          workSheetPages
          vocabularyEnPages
          vocabularyEsPages
          stimulusResourceIds
          activitiesBookmarks {
            version
            sectionIds
          }
        }
        ... on AssignedAssessmentData {
          type
          unitRubric
          aeRubric
          victorianRubric
          selfAssessment
          basicAssessmentPages
          summativeAssessmentPages
          formativeAssessmentPages
          socialAndEmotionalRubric
          differentiationPages
          stimulusResourceIds
          activitiesBookmarks {
            version
            sectionIds
          }
        }
      }
      linkedContent {
        ... on Lesson {
          id
          name
          notesJson
          authorId
          unitId
          slug
          sort
          integratedSort
          unit {
            id
            name
          }
          integratedUnit {
            id
            name
          }
          subjects {
            id
            label
            name
            colour
          }
          years {
            id
            name
          }
          ...StudentLessonLandscapeImageFragment
          ...StudentLessonSquareImageFragment
          ...StudentLessonWorksheetsFragment
          ...StudentLessonStimulusFragment
          ...StudentLessonPrintablesFragment
        }
        ... on Assessment {
          id
          name
          authorId
          overviewJson
          unitId
          slug
          sort
          integratedSort
          unit {
            id
            name
          }
          integratedUnit {
            id
            name
          }
          subjects {
            id
            label
            name
            colour
          }
          years {
            id
            name
          }
          ...StudentAssessmentLandscapeImageFragment
          ...StudentAssessmentSquareImageFragment
          ...StudentAssessmentWorksheetsFragment
          ...StudentAssessmentStimulusFragment
        }
      }
    }
  }
  ${ResponsiveImageFragment}
  ${SubjectFragment}
  ${studentLessonLandscapeImageFragment}
  ${studentLessonSquareImageFragment}
  ${studentLessonWorksheetsFragment}
  ${studentLessonStimulusFragment}
  ${studentLessonPrintablesFragment}
  ${studentAssessmentLandscapeImageFragment}
  ${studentAssessmentSquareImageFragment}
  ${studentAssessmentWorksheetsFragment}
  ${studentAssessmentStimulusFragment}
`;
